module.exports = __webpack_public_path__ + "static/img/监管能力.37baab96.png";